/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAdminsRouteImport } from './routes/_app.admins'
import { Route as AppDocsRouteImport } from './routes/_app.docs'
import { Route as AppDoctolibRouteImport } from './routes/_app.doctolib'
import { Route as AppEmailsRouteImport } from './routes/_app.emails'
import { Route as AppFormsRouteImport } from './routes/_app.forms'
import { Route as AppMessagesRouteImport } from './routes/_app.messages'
import { Route as AppReviewsRouteImport } from './routes/_app.reviews'
import { Route as AppSubscriptionsRouteImport } from './routes/_app.subscriptions'
import { Route as AppSyncsRouteImport } from './routes/_app.syncs'
import { Route as AppDocsIndexRouteImport } from './routes/_app.docs.index'
import { Route as AppDocsAppointmentSyncRouteImport } from './routes/_app.docs.appointment-sync'
import { Route as AppDocsDeliveryFailuresRouteImport } from './routes/_app.docs.delivery-failures'
import { Route as AppDocsSyncRouteImport } from './routes/_app.docs.sync'
import { Route as AppUsersIndexRouteImport } from './routes/_app.users.index'
import { Route as AppUsersIdRouteImport } from './routes/_app.users.$id'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminsRoute = AppAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsRoute = AppDocsRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => AppRoute,
} as any)
const AppDoctolibRoute = AppDoctolibRouteImport.update({
  id: '/doctolib',
  path: '/doctolib',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailsRoute = AppEmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => AppRoute,
} as any)
const AppFormsRoute = AppFormsRouteImport.update({
  id: '/forms',
  path: '/forms',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewsRoute = AppReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AppRoute,
} as any)
const AppSubscriptionsRoute = AppSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => AppRoute,
} as any)
const AppSyncsRoute = AppSyncsRouteImport.update({
  id: '/syncs',
  path: '/syncs',
  getParentRoute: () => AppRoute,
} as any)
const AppDocsIndexRoute = AppDocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDocsRoute,
} as any)
const AppDocsAppointmentSyncRoute = AppDocsAppointmentSyncRouteImport.update({
  id: '/appointment-sync',
  path: '/appointment-sync',
  getParentRoute: () => AppDocsRoute,
} as any)
const AppDocsDeliveryFailuresRoute = AppDocsDeliveryFailuresRouteImport.update({
  id: '/delivery-failures',
  path: '/delivery-failures',
  getParentRoute: () => AppDocsRoute,
} as any)
const AppDocsSyncRoute = AppDocsSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AppDocsRoute,
} as any)
const AppUsersIndexRoute = AppUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersIdRoute = AppUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/admins': typeof AppAdminsRoute
  '/docs': typeof AppDocsRouteWithChildren
  '/doctolib': typeof AppDoctolibRoute
  '/emails': typeof AppEmailsRoute
  '/forms': typeof AppFormsRoute
  '/messages': typeof AppMessagesRoute
  '/reviews': typeof AppReviewsRoute
  '/subscriptions': typeof AppSubscriptionsRoute
  '/syncs': typeof AppSyncsRoute
  '/docs/appointment-sync': typeof AppDocsAppointmentSyncRoute
  '/docs/delivery-failures': typeof AppDocsDeliveryFailuresRoute
  '/docs/sync': typeof AppDocsSyncRoute
  '/users/$id': typeof AppUsersIdRoute
  '/docs/': typeof AppDocsIndexRoute
  '/users/': typeof AppUsersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/admins': typeof AppAdminsRoute
  '/doctolib': typeof AppDoctolibRoute
  '/emails': typeof AppEmailsRoute
  '/forms': typeof AppFormsRoute
  '/messages': typeof AppMessagesRoute
  '/reviews': typeof AppReviewsRoute
  '/subscriptions': typeof AppSubscriptionsRoute
  '/syncs': typeof AppSyncsRoute
  '/': typeof AppIndexRoute
  '/docs/appointment-sync': typeof AppDocsAppointmentSyncRoute
  '/docs/delivery-failures': typeof AppDocsDeliveryFailuresRoute
  '/docs/sync': typeof AppDocsSyncRoute
  '/users/$id': typeof AppUsersIdRoute
  '/docs': typeof AppDocsIndexRoute
  '/users': typeof AppUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/admins': typeof AppAdminsRoute
  '/_app/docs': typeof AppDocsRouteWithChildren
  '/_app/doctolib': typeof AppDoctolibRoute
  '/_app/emails': typeof AppEmailsRoute
  '/_app/forms': typeof AppFormsRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/reviews': typeof AppReviewsRoute
  '/_app/subscriptions': typeof AppSubscriptionsRoute
  '/_app/syncs': typeof AppSyncsRoute
  '/_app/': typeof AppIndexRoute
  '/_app/docs/appointment-sync': typeof AppDocsAppointmentSyncRoute
  '/_app/docs/delivery-failures': typeof AppDocsDeliveryFailuresRoute
  '/_app/docs/sync': typeof AppDocsSyncRoute
  '/_app/users/$id': typeof AppUsersIdRoute
  '/_app/docs/': typeof AppDocsIndexRoute
  '/_app/users/': typeof AppUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admins'
    | '/docs'
    | '/doctolib'
    | '/emails'
    | '/forms'
    | '/messages'
    | '/reviews'
    | '/subscriptions'
    | '/syncs'
    | '/docs/appointment-sync'
    | '/docs/delivery-failures'
    | '/docs/sync'
    | '/users/$id'
    | '/docs/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/admins'
    | '/doctolib'
    | '/emails'
    | '/forms'
    | '/messages'
    | '/reviews'
    | '/subscriptions'
    | '/syncs'
    | '/'
    | '/docs/appointment-sync'
    | '/docs/delivery-failures'
    | '/docs/sync'
    | '/users/$id'
    | '/docs'
    | '/users'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/admins'
    | '/_app/docs'
    | '/_app/doctolib'
    | '/_app/emails'
    | '/_app/forms'
    | '/_app/messages'
    | '/_app/reviews'
    | '/_app/subscriptions'
    | '/_app/syncs'
    | '/_app/'
    | '/_app/docs/appointment-sync'
    | '/_app/docs/delivery-failures'
    | '/_app/docs/sync'
    | '/_app/users/$id'
    | '/_app/docs/'
    | '/_app/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admins': {
      id: '/_app/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AppAdminsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs': {
      id: '/_app/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof AppDocsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doctolib': {
      id: '/_app/doctolib'
      path: '/doctolib'
      fullPath: '/doctolib'
      preLoaderRoute: typeof AppDoctolibRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/emails': {
      id: '/_app/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof AppEmailsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forms': {
      id: '/_app/forms'
      path: '/forms'
      fullPath: '/forms'
      preLoaderRoute: typeof AppFormsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reviews': {
      id: '/_app/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof AppReviewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/subscriptions': {
      id: '/_app/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof AppSubscriptionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/syncs': {
      id: '/_app/syncs'
      path: '/syncs'
      fullPath: '/syncs'
      preLoaderRoute: typeof AppSyncsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/docs/': {
      id: '/_app/docs/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof AppDocsIndexRouteImport
      parentRoute: typeof AppDocsRoute
    }
    '/_app/docs/appointment-sync': {
      id: '/_app/docs/appointment-sync'
      path: '/appointment-sync'
      fullPath: '/docs/appointment-sync'
      preLoaderRoute: typeof AppDocsAppointmentSyncRouteImport
      parentRoute: typeof AppDocsRoute
    }
    '/_app/docs/delivery-failures': {
      id: '/_app/docs/delivery-failures'
      path: '/delivery-failures'
      fullPath: '/docs/delivery-failures'
      preLoaderRoute: typeof AppDocsDeliveryFailuresRouteImport
      parentRoute: typeof AppDocsRoute
    }
    '/_app/docs/sync': {
      id: '/_app/docs/sync'
      path: '/sync'
      fullPath: '/docs/sync'
      preLoaderRoute: typeof AppDocsSyncRouteImport
      parentRoute: typeof AppDocsRoute
    }
    '/_app/users/': {
      id: '/_app/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof AppUsersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users/$id': {
      id: '/_app/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof AppUsersIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppDocsRouteChildren {
  AppDocsAppointmentSyncRoute: typeof AppDocsAppointmentSyncRoute
  AppDocsDeliveryFailuresRoute: typeof AppDocsDeliveryFailuresRoute
  AppDocsSyncRoute: typeof AppDocsSyncRoute
  AppDocsIndexRoute: typeof AppDocsIndexRoute
}

const AppDocsRouteChildren: AppDocsRouteChildren = {
  AppDocsAppointmentSyncRoute: AppDocsAppointmentSyncRoute,
  AppDocsDeliveryFailuresRoute: AppDocsDeliveryFailuresRoute,
  AppDocsSyncRoute: AppDocsSyncRoute,
  AppDocsIndexRoute: AppDocsIndexRoute,
}

const AppDocsRouteWithChildren =
  AppDocsRoute._addFileChildren(AppDocsRouteChildren)

interface AppRouteChildren {
  AppAdminsRoute: typeof AppAdminsRoute
  AppDocsRoute: typeof AppDocsRouteWithChildren
  AppDoctolibRoute: typeof AppDoctolibRoute
  AppEmailsRoute: typeof AppEmailsRoute
  AppFormsRoute: typeof AppFormsRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppReviewsRoute: typeof AppReviewsRoute
  AppSubscriptionsRoute: typeof AppSubscriptionsRoute
  AppSyncsRoute: typeof AppSyncsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppUsersIdRoute: typeof AppUsersIdRoute
  AppUsersIndexRoute: typeof AppUsersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAdminsRoute: AppAdminsRoute,
  AppDocsRoute: AppDocsRouteWithChildren,
  AppDoctolibRoute: AppDoctolibRoute,
  AppEmailsRoute: AppEmailsRoute,
  AppFormsRoute: AppFormsRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppReviewsRoute: AppReviewsRoute,
  AppSubscriptionsRoute: AppSubscriptionsRoute,
  AppSyncsRoute: AppSyncsRoute,
  AppIndexRoute: AppIndexRoute,
  AppUsersIdRoute: AppUsersIdRoute,
  AppUsersIndexRoute: AppUsersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
